import { render, staticRenderFns } from "./batchTable.vue?vue&type=template&id=54995647&scoped=true&"
import script from "./batchTable.vue?vue&type=script&lang=js&"
export * from "./batchTable.vue?vue&type=script&lang=js&"
import style0 from "./batchTable.vue?vue&type=style&index=0&id=54995647&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54995647",
  null
  
)

export default component.exports